// extracted by mini-css-extract-plugin
export default {"ViewMore":"LoadMore_ViewMore__twbCV","ViewMoreText":"LoadMore_ViewMoreText__fsy-j"};